import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        await api.post("/auth/refresh");
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch (e) {
        setUser(false);
      }
    });
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  }, []);

  const register = useCallback(async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout");
    setUser(false);
  }, []);

  const toggleSaved = useCallback(async (venueId) => {
    const saved = user?.saved?.includes(venueId);
    const r = saved ? await api.delete(`/me/saved/${venueId}`) : await api.post(`/me/saved/${venueId}`);
    setUser((u) => ({ ...u, saved: r.data.saved }));
    return !saved;
  }, [user]);

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, toggleSaved }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
